import React from "react";
import "../../../css/DesignSystem/SummaryCards/SummaryCards.css";

const DEFAULT_TONE = "blue";

const TONE_CLASS_MAP = {
  blue: "fp-summary-card-blue",
  cream: "fp-summary-card-cream",
  green: "fp-summary-card-green",
  purple: "fp-summary-card-purple",
  teal: "fp-summary-card-teal",
  pink: "fp-summary-card-pink",
};

const SummaryCards = ({
  cards = [],
  className = "",
  gridClassName = "",
  grid = "3",
  emptyText = "No summary data available.",
  loading = false,
}) => {
  if (!cards.length) {
    return <div className="fp-summary-empty">{emptyText}</div>;
  }

  return (
    <section className={`fp-summary-grid-${grid} fp-summary-grid-loading-container ${gridClassName} ${className}`.trim()} aria-busy={loading}>
      {cards.map((card) => {
        const tone = card.tone || DEFAULT_TONE;
        const toneClass = TONE_CLASS_MAP[tone] || TONE_CLASS_MAP[DEFAULT_TONE];

        return (
          <div
            key={card.id || card.label}
            className={`fp-summary-card ${toneClass} ${card.onClick ? "fp-summary-card-clickable" : ""} ${card.className || ""}`.trim()}
            role={card.onClick ? "button" : undefined}
            tabIndex={card.onClick ? 0 : undefined}
            onClick={card.onClick}
            onKeyDown={
              card.onClick
                ? (event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      card.onClick();
                    }
                  }
                : undefined
            }
          >
            <span>{card.label}</span>
            {card.period && (
              <span className="fp-summary-card-period">{card.period}</span>
            )}

            <div className="FP_Title text-black">{card.value ?? "-"}</div>

            {card.description && <p>{card.description}</p>}
          </div>
        );
      })}
      {loading && <div className="fp-summary-loading-overlay" role="status">Loading totals…</div>}
    </section>
  );
};

export default SummaryCards;
